import {
  BUSSINESS,
  BUSSINESS_SUBJECTS,
  SENSITIVE_WORDS,
  SUBJECTS,
  USER_GROUPS,
  USER_NAME
} from '../../service/constant'

const state = {
  version: '1.1.1',
  [USER_NAME]: '',
  [USER_GROUPS]: [],
  [SENSITIVE_WORDS]: [],
  [BUSSINESS]: [],
  [SUBJECTS]: [],
  [BUSSINESS_SUBJECTS]: {}
}

export default state
